import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import Validation from "@irati/utils/validation"
import {Radio, ToolTipRenderer} from "@irati/ui/src/FormItem"

import {USER_REMINDER_AFTER_DAYS_PROPERTY} from "@irati-web/fields/schedule"

export const PROPERTY = "periodValue"
export const QUESTION_COUNT_PROPERTY = "preferences.questionCount"
export const schema = (formatMessage) => Validation.number(formatMessage({id: "insights.validation.required"}))

class PeriodValue extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    label: PropTypes.string,
    name: PropTypes.string,
    formatMessage: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    name: PROPERTY,
    label: null,
    disabled: false
  }

  toolTipOptions = [
    {
      label: this.props.formatMessage({id: `insights.fields.schedule.${PROPERTY}.option1.label`}),
      value: 1,
      tooltip: this.props.formatMessage({id: `insights.fields.schedule.${PROPERTY}.option1.tooltip`})
    },
    {
      label: this.props.formatMessage({id: `insights.fields.schedule.${PROPERTY}.option2.label`}),
      value: 2,
      tooltip: this.props.formatMessage({id: `insights.fields.schedule.${PROPERTY}.option2.tooltip`})
    },
    {
      label: this.props.formatMessage({id: `insights.fields.schedule.${PROPERTY}.option3.label`}),
      value: 4,
      tooltip: this.props.formatMessage({id: `insights.fields.schedule.${PROPERTY}.option3.tooltip`})
    }
  ]

  handlePeriodChange = (periodValue) => {
    const {onChange, schedule, name} = this.props

    const changes = {
      [QUESTION_COUNT_PROPERTY]: this.getDefaultQuestionCount(periodValue),
      [USER_REMINDER_AFTER_DAYS_PROPERTY]: this.getDefaultAfterDaysValue(schedule, periodValue),
      [name]: periodValue
    }

    onChange(null, changes)
  }

  getDefaultQuestionCount = (selectedFrequency) => {
    switch (selectedFrequency) {
      case 2:
        return 10
      case 4:
        return 15
      case 1:
      default:
        return 5
    }
  }

  getDefaultAfterDaysValue = (schedule, selectedFrequency) => {
    const currentValue = get(schedule, USER_REMINDER_AFTER_DAYS_PROPERTY)
    if (currentValue) {
      switch (selectedFrequency) {
        case 2:
          return 7
        case 4:
          return 14
        default:
          return 3
      }
    }
    return 0
  }

  render() {
    const idNamespace = id("PeriodValue", this.props)
    const {
      schedule: {periodValue: value},
      name,
      label,
      formatMessage,
      disabled
    } = this.props
    const intlLabel = label || formatMessage({id: `insights.fields.schedule.${PROPERTY}.label`})

    return (
      <>
        <Radio
          label={intlLabel}
          rowRenderer={ToolTipRenderer}
          disabled={disabled}
          id={idNamespace}
          name={name}
          value={value}
          onChange={this.handlePeriodChange}
          options={this.toolTipOptions} />
      </>
    )
  }
}

export default injectIntl(PeriodValue)
